




















module.exports =
  props: ['users_options']

  components:
    liveFeedEventListItem: require('./live_feed_event_list_item')

  data: ->
    events: []
    subscription: null
    user_filter: null
    current_user: Session.current_user
    max_events: 30
    loading: true

  methods:
    subscribeToLiveFeedChannel: ->
      user_id = @user_filter?.user_id_eq
      @removeSubscription()
      @subscription = ActionCable.cable.subscriptions.create { channel: 'LiveFeedChannel', user_id: user_id },
        received: (event_data) =>
          if ((@user_filter?.user_id_eq && event_data.user.id == @user_filter.user_id_eq) || @user_filter == null)
            contact_event = new ContactEvent(event_data)
            @events.unshift(contact_event)
            @events.splice(-1) if @events.length > @max_events

    removeSubscription: ->
      ActionCable.cable.subscriptions.remove(@subscription) if @subscription
      @subscription = null

    loadLiveFeedEvents: ->
      @events = []
      @loading = true
      filters = if @user_filter then { user_id: @user_filter.user_id_eq } else {}
      return @loadNewLiveFeed() if Session.current_user.extradata.new_live_feed
      new ReportsResource(Session.current_company.id).liveFeedEvents(@loadLiveFeedEventsSuccess, @loadLiveFeedEventsFailure, params: { q: filters })

    loadLiveFeedEventsSuccess: (data) ->
      @loading = false
      @subscribeToLiveFeedChannel()
      @events = data.events

    loadLiveFeedEventsFailure: ->
      @loading = false
      alertify.error('Ops, houve um erro ao carregar o live feed')

    loadNewLiveFeed: ->
      path = "https://#{process.env.LIVE_FEED_EVENTS_URL + process.env.BASE_API_GATEWAY_URL}/liveFeed"
      headers = { 'authorization': process.env.LAMBDA_AUTORIZATION, 'x-user-token': Session.current_user.authentication_token }
      filters = { company_id: Session.current_company.id }
      filters = { user_id: @user_filter.user_id_eq } if @user_filter
      jQuery.ajax({
        url: path,
        headers: headers,
        data: filters,
        success: @loadLiveFeedSuccessNewEvents
        error: @unknownError
      })

    loadLiveFeedSuccessNewEvents: (resources) ->
      count = 0
      events = resources.events.map (event) ->
        event.id = ++count
        new ContactEvent(event)
      @loadLiveFeedEventsSuccess({ events })

  created: ->
    @loadLiveFeedEvents()




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/live_feed.vue